import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { getTranslations } from "../Shared/translations"
import "./addCtd.css";
interface MyProps {
  visible: string;
  onDataChange: (t: any) => any;
  onSave: (t: any) => any;
}

const AddCtd: React.FC<MyProps> = ({ visible, onDataChange, onSave }) => {
  let ctdNaam = "";
  const t = getTranslations();
  const handleClose = () => {
    onDataChange({ settings: "hidden" });
  };

  const handleSave = () => {
    onSave(ctdNaam);
    onDataChange({ settings: "hidden" });
  };

  const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    ctdNaam = event.target.value;
  };

  return (
    <Modal show={visible === "addctd"}>
      <Modal.Header closeButton onClick={handleClose}>
        <Modal.Title>
          <h2>{t.voegCtdToe}</h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {t.naamCtd} 
        <span className="ctd-icon">
            ℹ
            <span className="ctd-tooltip">
              {t.naamCtdTip}
            </span>
          </span>
        <br />
        <input
          type="text"
          onChange={handleTextChange}
          //defaultValue={sessionStorage.getItem("bestandsnaam") || ""}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleSave}>
          {t.bewaar}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddCtd;
